import { IssueTrackerFileDTO } from "./issue-tracker-file-dto";
import { IssueTrackerIncidenceDataDTO } from "./issue-tracker-incidence-data-dto";

export class IssueTrackerTagDTO
{
    IdTag?: string;
    Tag: string;
    Color: string;
}

export class IssueTrackerIncidenceFilterDTO
{
    IdClients: string[];
    IdProjects: string[];
    IdStatus: number[];
    IdTags: string[];
}

export class IssueTrackerIncidencePostDTO
{
    IdProject: string;
    Subject: string;
    Message: string;
    ContactEmail: string;
    EmailCc?: string;
    ContactData?: string;
    FileAttachedFile?: File;
    CreatedAsManager?: boolean;
}

export class IssueTrackerIncidenceDTO
{
    IdIncidence: string;
    ClientName: string;
    ProjectName: string;
    IdStatus: number;
    Status: string;
    CreationDate: Date;
    LastUpdateDate: Date;
    Subject: string;
    IncidenceCode: string;
    ContactEmail: string;
    ContactData?: string;
    Tags?: IssueTrackerTagDTO[];
    ProjectImageIconFile: IssueTrackerFileDTO;
    HtmlWebCustomFile: IssueTrackerFileDTO;
    CssFileFile: IssueTrackerFileDTO;
    Messages: IssueTrackerIncidenceDataDTO[];
    ItResponse?: string | null;
    ItResponseUserName?: string | null;
    ItResponseDate?: string | null;
    CanViewItResponse: boolean;
    CanEditItResponse: boolean;
    PhoneCallNeeded: boolean;
    NoAutoClose: boolean;
    ProjectSignature?: string | null;
}

export class IssueTrackerIncidenceDatatableDTO
{
    IdIncidence: string;
    ClientName: string;
    ProjectName: string;
    IdStatus: number;
    Status: string;
    CreationDate: string;
    LastUpdateDate: string;
    Subject: string;
    IncidenceCode: string;
    ContactEmail: string;
    ProjectImageIconFile: IssueTrackerFileDTO;
    HasItResponse: boolean | null;
}

export class IssueTrackerIncidenceHighligthDTO
{
    IdClient: string;
    IdProject: string;
    ClientName: string;
    ProjectName: string;
    ProjectIconFileUri: string;
    TotalIncidencesByStatus: Map<string, number>;
    AverageMessagesByStatus: Map<string, number>;
    PhoneCallIncidences: number;
    PhoneCallPercentage: number;
}
